import React from 'react';
import '../styles/PageTransition.css';

const PageTransition = ({ isActive }) => {
  return (
    <div className={`page-transition ${isActive ? 'active' : ''}`}>
      <div className="transition-overlay" />
      <img 
        src="/logo.png" 
        alt="Plasma Logo" 
        className="transition-logo"
      />
    </div>
  );
};

export default PageTransition; 